var exports = {
  "kL": "xdbfd91f1--dae181--container",
  "DD": "xdbfd91f1--dae181--title",
  "h_": "xdbfd91f1--dae181--description",
  "lZ": "xdbfd91f1--dae181--phone",
};

module.exports = exports;
